import { sort } from '@10000/common'

const comparatorCallbacks = {
  'name': sort.by,
  'country': sort.by,
  'city': sort.by,
  'industry': sort.by,
  'onboarded': sort.by,
  'created': sort.by,
  'organisations': sort.by,
  'teams': sort.by,
  'users': sort.by,
  'squizzes': sort.by,
}

export const sortRows = sortColumns => (a, b) => {
  for (const sort of sortColumns) {
    const comparator = comparatorCallbacks[sort.columnKey]
    const compResult = comparator(sort.columnKey, sort.direction === 'DESC')(a, b)
    if (compResult !== 0) {
      return compResult
    }
  }
  return 0
}

export const sortColumn = (columnsSelected) => columnsSelected.length > 0 ? [columnsSelected[columnsSelected.length - 1]] : columnsSelected
